import React, {
    useCallback, useMemo, useContext,
    useEffect,
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { DropdownSelectField, InputField } from '@jutro/legacy/components';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import styles from './InvestmentTableComponent.module.scss';
import metadata from './InvestmentTableComponent.metadata.json5';
import messages from './InvestmentTableComponent.messages.js';
import { TranslatorContext } from '@jutro/legacy/locale';

function InvestmentTableComponent(props) {

    const {
        data: InvestmentTableVM,
        updateWizardData,
        submissionVM,
        InvestmentTablePath
    } = props;
    const translator = useContext(TranslatorContext);


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);

        const investmentDataVM = _.get(
            submissionVM,
            'lobData.proLine.coverables.lifeAgentsCoverable.additionalInfo.investmentTable',
            { value: [] }
        );

        const totalAmount = investmentDataVM.value.reduce((sum, item) => {
            const rawAmount = _.get(item, 'groCom2.amount', 0);
            const amount = Number(rawAmount);

            return sum + amount;
        }, 0);


        // eslint-disable-next-line no-secrets/no-secrets
        _.set(submissionVM, 'lobData.proLine.coverables.lifeAgentsCoverable.additionalInfo.groComTot8.amount', totalAmount);

        },
        [submissionVM, updateWizardData]
    );

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'inv1') {
                const value = (item && item.inv1) ? item.inv1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = InvestmentTableVM.length > 0 && InvestmentTableVM.children[index].inv1
                    // eslint-disable-next-line security/detect-object-injection
                    ? _.sortBy(InvestmentTableVM.children[index].inv1.aspects.availableValues, 'priority')
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        readOnly
                    />
                );
            }

            if (path === 'groCom2') {
                const value = item.groCom2 ? item.groCom2 : '';

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            item.groCom2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'des3') {
                const value = item.des3 ? item.des3 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }
    }, [InvestmentTableVM.children, InvestmentTableVM.length, handleValueChange, translator])
    
    const totalAmountVM = _.get(
        submissionVM,
        // eslint-disable-next-line no-secrets/no-secrets
        'lobData.proLine.coverables.lifeAgentsCoverable.additionalInfo.groComTot8.amount'
    );

    const totalAmount = totalAmountVM?.value ?? 0;

    const overrideProps = useMemo(() => ({
        '@element': {
            showOptional: false,
            showRequired: true
        },
        [`InvestmentTableTable`]: {
            data: InvestmentTableVM.value,
        },
        groComTot8: {
            readOnly: true,
            value: `$${totalAmount}`
        },
        des3TypeHeader: {
            header: [undefined, '', '0', 0, null].includes(_.get(submissionVM, 'lobData.proLine.coverables.lifeAgentsCoverable.value.additionalInfo.investmentTable[3].groCom2.amount')) 
            ? `${translator(messages.des3)}` : `* ${translator(messages.des3)}`
        }
    }), [InvestmentTableVM.value, submissionVM, totalAmount, translator])

    const resolvers = {
        resolveCallbackMap: {
            getTableCell
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            InvestmentTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [InvestmentTableVM, overrideProps]
    );

    useEffect(() => {
        const investments = _.get(submissionVM, `${InvestmentTablePath}.value`);

        _.each(investments, (investment) => {
            // eslint-disable-next-line no-param-reassign
            investment.isValidationReq = true;
        });
    }, [InvestmentTablePath, submissionVM])

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={InvestmentTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

InvestmentTableComponent.propTypes = wizardProps;
export default withRouter(InvestmentTableComponent);
